import { render, staticRenderFns } from "./footer-top.vue?vue&type=template&id=4d4258e6&scoped=true"
var script = {}
import style0 from "./footer-top.vue?vue&type=style&index=0&id=4d4258e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4258e6",
  null
  
)

export default component.exports